import React from "react";
import ListSection from "./list/ListSection";

export default function PastSubscriptionSubPage() {
  return (
    <ListSection />
  );
}
